<template>
  <div>
    <v-dialog v-model="isOpen" max-width="400" persistent>
      <v-card class="confirm-card" elevation="0">
        <div class="content">
          <div class="title">Adicionar ajuste por item</div>

          <div class="subtitle">
            {{ produto.id_produto }} - {{ produto.descricao_produto }}
          </div>

          <div class="mb-5 w-100-porcento">
            <v-form v-model="form_valido" ref="form_ref">
              <h3 class="font-14 text-start mb-1">Ajuste do item (%)</h3>

              <v-text-field
                class="input-clean"
                v-model="form.influencia"
                :rules="rules.rangeInfluencia"
                hide-details="auto"
                label="0"
                append-icon="$Percent"
                color="#39404B"
                outlined
                dense
                single-line
                maxlength="5"
                @keydown.enter.prevent
                @keydown="caracteresNaoPermitidos"
              />
            </v-form>
          </div>

          <v-btn class="btn-cancel" block large outlined @click="cancelar">
            Cancelar
          </v-btn>

          <v-btn class="btn-delete" block large depressed @click="confirmar">
            Salvar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue";
import { toast2 } from "@/components/utils/ui_v4/alerts/toast/toast2";

const emit = defineEmits(["fechar", "confirmar"]);

const props = defineProps({
  value: { type: Boolean, default: false },
  produto: { type: Object }
});

const dialog = ref(props.value);
const formInicial = () => ({
  influencia: ''
});

const form_ref = ref(null);
const form_valido = ref(false);

const form = reactive(formInicial());

watch(
  () => props.value,
  (v) => {
    dialog.value = v;
    form.influencia = props.produto.percentual_influencia;
  }
);

const isOpen = computed({
  get: () => dialog.value,
  set: (v) => (dialog.value = v),
});

function cancelar() {
  isOpen.value = false;
  emit("fechar");
}

function confirmar() {
  if (!form_valido.value) {
    return;
  }

  if (String(form.influencia).includes(',')) {
    toast2.error('Influência não aplicada', "Use ponto '.' ao invés de vírgula ','");
    return;
  }

  isOpen.value = false;
  emit("confirmar", form.influencia);
}

function caracteresNaoPermitidos(e) {
  if (e.key === ',') e.preventDefault();
  if (e.key === '%') e.preventDefault();
}

const range = (
  msg = "A influência deve respeitar os limites definidos (mínimo -100%, máximo +100%)"
) => (v) => {
  let n = v;

  if (typeof v === "string" && v.trim() === "") return msg;
  if (typeof n === "string") n = n.trim().replace("%", "").replace(",", ".");

  const num = Number(n);
  if (!Number.isFinite(num)) return msg;

  return num >= -100 && num <= 100 ? true : msg;
};

const rules = {
  rangeInfluencia: [range()]
};
</script>

<style scoped>
.confirm-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}

.content {
  padding: 28px 26px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: 500;
  color: #39404B;
  margin-top: 10px;
  margin-bottom: 15px;
}

.subtitle {
  font-size: 16px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.6);
  max-width: 420px;
  margin-bottom: 30px;
}

.btn-cancel {
  border-radius: 7px;
  border: none;
  color: #4075FF !important;
  text-transform: none;
  font-weight: 500;
  height: 48px;
  margin-bottom: 12px;
}

.btn-delete {
  border-radius: 7px;
  background: #4075FF !important;
  color: #fff !important;
  text-transform: none;
  font-weight: 500;
  height: 50px;
}

::v-deep(.input-clean.v-text-field--outlined .v-input__control > .v-input__slot) {
  background: #fff;
  border-radius: 4px;
  min-height: 50px;
  padding: 10px;
}

::v-deep(.input-clean.v-text-field--outlined fieldset) {
  border-width: 1px;
}

::v-deep(.input-clean.v-text-field--outlined .v-label) {
  color: #73787F;
  text-align: center;
  font-size: 14px;
}
</style>
